import { graphql, useStaticQuery } from "gatsby";

import IndexPost, {
  fromIndexPostContentfulBlogPostFragment,
} from "../blog/IndexPost";

const TipCustomerRetentionExamplesTopCompanies: React.FunctionComponent =
  () => {
    const { contentfulBlogPost: post } = useStaticQuery(graphql`
      query {
        contentfulBlogPost(
          slug: { eq: "customer-retention-companies-examples" }
        ) {
          ...IndexPostContentfulBlogPostFragment
        }
      }
    `);

    return <IndexPost {...fromIndexPostContentfulBlogPostFragment(post)} />;
  };

export default TipCustomerRetentionExamplesTopCompanies;
